<div class="root-container" #container>
  
  <div class="section-caption">
    Hedge Positions
    <span *ngIf="this.underlyingBadge" class="underlying-header-badge">{{ this.underlyingBadge }}</span>
  </div>
  
  <div class="positions-section">
    
    <!-- N/A -->
    <ng-container *ngIf="!this.hasLegs">
      <div class="na">
        N/A
      </div>
      <ng-container *ngIf="this.hasPortfolio">
        <ng-container *ngTemplateOutlet="separator2"></ng-container>
      </ng-container>
    </ng-container>
    
    <ng-container *ngIf="this.hasCalls">
      <ng-container *ngTemplateOutlet="positions; context: {$implicit: {side: 'Call'}}"></ng-container>
    </ng-container>
    
    <ng-container *ngIf="this.hasLegs && this.hasCalls">
        <ng-container *ngTemplateOutlet="separator2"></ng-container>
    </ng-container>
    
    <ng-container *ngIf="this.hasPuts">
      <ng-container *ngTemplateOutlet="positions; context: {$implicit: {side: 'Put'}}"></ng-container>
    </ng-container>
    
    <ng-container *ngIf="this.hasLegs && this.hasPuts && !this.hasCalls">
      <ng-container *ngTemplateOutlet="separator2"></ng-container>
    </ng-container>
    
    <ng-container *ngIf="this.hasPortfolio">
      <div class="buttons">
        
        <ng-container *ngIf="this.getAfterStateCount() == 2">
          <div class="btn clear-after-state">
            <dx-drop-down-button
              [items]="['All', 'Calls', 'Puts']"
              (onItemClick)="this.clearAfterState($event.itemData)"
              [disabled]="!this.hasAnyAfterState()"
              [showArrowIcon]="false"
              text="Clear Saved State"
              type="normal"
              width="100%"
            ></dx-drop-down-button>
          </div>
        </ng-container>
        
        <ng-container *ngIf="this.getAfterStateCount() < 2">
          <div class="btn clear-after-state">
            <dx-button
              (onClick)="this.clearAfterState()"
              [disabled]="!this.hasAnyAfterState()"
              text="Clear Saved State"
              type="normal"
              width="100%"
            ></dx-button>
          </div>
        </ng-container>
        
        <div class="btn clear-all">
          <dx-button text="Clear Hedges" width="100%" (onClick)="this.clearHedges()"></dx-button>
        </div>

        <div class="btn defaults">
          <dx-button width="100%" text="Load Defaults" (onClick)="this.resetToDefaults()">
          </dx-button>
        </div>
      </div>
    </ng-container>
  
  </div>
  
  <dx-load-panel [visible]="this.isLoading" [position]="{my: 'center', at: 'center', of: container}">
  </dx-load-panel>
</div>

<ets-hg-after-state-preview></ets-hg-after-state-preview>

<ng-template #separator2>
  <div class="separator double">
    <div (click)="this.showAfterStatePreview('first')" [class.hot]="this.hasAfterState('first')"
         class="button"
    >
      C
    </div>
    <div class="line double">
      <hr style="width: 100px">
    </div>
    <div (click)="this.showAfterStatePreview('second')" [class.hot]="this.hasAfterState('second')"
         class="button"
    >
      P
    </div>
  </div>
</ng-template>

<ng-template #positions let-ctx>
  <ng-container *ngFor="let pGroup of this.getLegGroups(ctx.side); last as isLast">
    
    <div [style.border-color]="pGroup.groupColor" [style.color]="pGroup.groupColor" class="group-label">
      <span *ngIf="pGroup.underlyingDisplayName && this.esHedgingEnabled" class="underlying-badge">{{ pGroup.underlyingDisplayName }}</span>
      <span>{{ pGroup.groupLabel }}</span>
      <span>
        <i (click)="this.removeHedge(pGroup, ctx.side)" class="fa fa-times-circle remove-group"></i>
      </span>
    </div>
    
    <div *ngFor="let hedgePosition of pGroup.legs" class="position">
      
      <div class="part side">
        <dx-text-box [inputAttr]="{'style': ('color: ' + pGroup.groupColor)}"
                     [readOnly]="true"
                     [disabled]="this.isLegExpired(hedgePosition)"
                     [value]="hedgePosition.side"
        ></dx-text-box>
      </div>
      
      <div class="part qty">
        <dx-number-box [inputAttr]="{'style': ('color: ' + pGroup.groupColor)}"
                       [readOnly]="true"
                       [value]="hedgePosition.qty"
                       [disabled]="this.isLegExpired(hedgePosition)"
        ></dx-number-box>
      </div>
      
      <div class="part type">
        <dx-text-box [inputAttr]="{'style': ('color: ' + pGroup.groupColor)}"
                     [readOnly]="true"
                     [value]="hedgePosition.type"
                     [disabled]="this.isLegExpired(hedgePosition)"
        ></dx-text-box>
      </div>
      
      <div [ngClass]="{'dependent': false}" class="part expiration">
        <ng-container *ngIf="this.isLegExpired(hedgePosition)">
          <dx-text-box [inputAttr]="{style: 'text-align: center; color: ' + pGroup.groupColor}"
                       [readOnly]="true"
                       [disabled]="true"
                       [value]="this.getExpiredLegExpirationText(hedgePosition)">
          </dx-text-box>
        </ng-container>
        <ng-container *ngIf="!this.isLegExpired(hedgePosition)">
          
          <ets-expiration-selector
            [expirationDescriptors]="hedgePosition.expirationList"
            [readOnly]="true"
            [disabled]="this.isLegExpired(hedgePosition)"
            [selectedExpiration]="hedgePosition.expirationDescriptor"
            [inputAttr]="{'style': ('color: ' + pGroup.groupColor)}"
          ></ets-expiration-selector>
        </ng-container>
      </div>
      
      <div class="part strike">
        <dx-number-box
          [inputAttr]="{'style': ('color: ' + pGroup.groupColor)}"
          [readOnly]="true"
          [value]="hedgePosition.strike"
          [disabled]="this.isLegExpired(hedgePosition)"
        ></dx-number-box>
      </div>
    </div>
    
  </ng-container>
</ng-template>

<ets-generic-confirmation-dialog title="Please Confirm Action">
</ets-generic-confirmation-dialog>
